<div class="export-picker">
  <button
    class="export-btn"
    (click)="handleButtonClick()"
    [disabled]="disabled">
    <span class="export-text">
      Exportar
    </span>
    <img
      *ngIf="canChoose"
      src="assets/icons/arrowDownCalendar.png"
      alt="Exportar documentos"
      class="export-arrow"
      [class.rotated]="isTypePickerOpen || isExportPickerOpen">
  </button>

  <!-- Popup de escolha de tipo (só aparece se canChoose for true) -->
  <div class="type-picker-selector" *ngIf="canChoose && isTypePickerOpen">
    <div class="selector-content">
      <!-- Título -->
      <div class="export-title">
        Selecione o tipo do arquivo que será exportado
      </div>

      <!-- Botões de escolha -->
      <div class="type-options">
        <button
          class="type-option-btn"
          [class.active]="selectedExportType === 'PDF'"
          (click)="selectExportType('PDF')">
          PDF
        </button>
        <button
          class="type-option-btn"
          [class.active]="selectedExportType === 'EXCEL'"
          (click)="selectExportType('EXCEL')">
          Excel
        </button>
      </div>

      <!-- Botão de cancelar -->
      <div class="export-actions">
        <button class="btn-cancel" (click)="openTypePicker()">
          Cancelar
        </button>
      </div>
    </div>
  </div>

  <!-- Popup de seleção de período (só para Excel) -->
  <div class="export-selector" *ngIf="isExportPickerOpen">
    <div class="selector-content">
      <!-- Título -->
      <div class="export-title">
        Selecione o período para exportação
      </div>

      <!-- Container para os dois seletores lado a lado -->
      <div class="period-sections-container">
        <!-- Período INICIAL -->
        <div class="period-section">
          <div class="period-label">Exercício Inicial</div>

          <!-- Seletor estilo exercise-calendar -->
          <div class="period-selector-initial">
            <div class="period-picker">
              <div class="period-selector">
                <div class="selector-content">
                  <div class="year-selector-container">
                    <select
                      class="year-selector"
                      [(ngModel)]="startYear"
                      (change)="onStartYearChange()"
                      [disabled]="disabled">
                      <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
                    </select>
                  </div>

                  <div class="month-grid">
                    <button
                      *ngFor="let month of monthNames; let i = index"
                      class="month-btn"
                      [class.active]="startMonth === i + 1"
                      [class.disabled]="isStartMonthDisabled(i + 1)"
                      (click)="selectStartMonth(i + 1)"
                      [disabled]="isStartMonthDisabled(i + 1)">
                      {{ getShortMonthName(month) }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Período FINAL -->
        <div class="period-section">
          <div class="period-label">Exercício Final</div>

          <!-- Seletor estilo exercise-calendar -->
          <div class="period-selector-final">
            <div class="period-picker">
              <div class="period-selector">
                <div class="selector-content">
                  <div class="year-selector-container">
                    <select
                      class="year-selector"
                      [(ngModel)]="endYear"
                      (change)="onEndYearChange()"
                      [disabled]="disabled">
                      <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
                    </select>
                  </div>

                  <div class="month-grid">
                    <button
                      *ngFor="let month of monthNames; let i = index"
                      class="month-btn"
                      [class.active]="endMonth === i + 1"
                      [class.disabled]="isEndMonthDisabled(i + 1)"
                      (click)="selectEndMonth(i + 1)"
                      [disabled]="isEndMonthDisabled(i + 1)">
                      {{ getShortMonthName(month) }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Período Selecionado -->
      <div class="selected-period-display" *ngIf="startMonth && endMonth">
        {{ formatPeriodDisplay() }}
      </div>

      <!-- Botões de ação -->
      <div class="export-actions">
        <button class="btn-cancel" (click)="cancelExport()">
          Cancelar
        </button>
        <button
          class="btn-export"
          (click)="confirmExport()"
          [disabled]="!isValidPeriod()">
          Exportar
        </button>
      </div>
    </div>
  </div>
</div>
